import { atom } from "recoil";

export const orientationAtom = atom({
    key: 'orientation',
    default: "portrait-primary",
  });